import { createContext } from "react";
var MatomoContext = createContext(null);
export default MatomoContext;
